export default __webpack_public_path__ + "static/media/click-through-prototype.eeb37273.svg";